export default __webpack_public_path__ + "static/O0317-8dc0dd7eb427f3818e5dddba2297ba5b.png";